import { render, staticRenderFns } from "./OrganizationTagDeleteDialog.vue?vue&type=template&id=3671683c&scoped=true"
import script from "./OrganizationTagDeleteDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationTagDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671683c",
  null
  
)

export default component.exports